var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.metaEnv === 'private_ad')?_c('LoginBody'):_c('LandingPage')}
var staticRenderFns = []

export { render, staticRenderFns }